<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>测算管理</el-breadcrumb-item>
          <el-breadcrumb-item>测算编辑</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="测算信息" name="account">
            <div class="tab-content">
              <el-form
                ref="editForm1"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
              >
                <el-form-item label="所属季别" label-width="120px">
                  <el-select
                    v-model="model.seasonType"
                    @change="getSeasons"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in seasonList"
                      :key="item.id"
                      :label="item.dicName"
                      :value="item.dicValue"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <div class="demo-input-suffix" style="display: flex">
                  <div style="width: 30%; line-height: 35px">具体月数</div>
                  <el-input placeholder="请输入内容" v-model="model.seasonMark">
                  </el-input>
                </div>
                <div class="demo-input-suffix" style="display: flex">
                  <div style="width: 30%; line-height: 35px">总月数</div>
                  <el-input placeholder="请输入内容" v-model="model.monthCount">
                  </el-input>
                </div>
                <el-col>
                  <el-card shadow="hover" style="min-width: 620px">
                    <div class="dl-box">
                      <ul>
                        <li
                          style="margin-bottom: 12px"
                          v-for="(fee, index) in model.periodList"
                          :key="index"
                        >
                          {{ fee.startTime }}
                          <span style="margin: 0 10px 22px">至</span>
                          {{ fee.endTime }}
                          <span style="margin: 0 10px 22px"></span>
                          <el-select
                            v-model="fee.chargeType"
                            class="myselect"
                            placeholder="请选择..."
                          >
                            <el-option
                              v-for="item in modeList"
                              :key="item.id"
                              :label="item.title"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>

                          <el-select
                            v-model="fee.priceType"
                            class="myselect"
                            placeholder="请选择..."
                          >
                            <el-option
                              v-for="item in feeList"
                              :key="item.priceType"
                              :label="item.title"
                              :value="item.priceType"
                            >
                            </el-option>
                          </el-select>

                          <el-input
                            v-model="fee.maxPower"
                            style="width: 100px"
                            placeholder="最大充电功率"
                          ></el-input>
                          kW

                          <el-button
                            type="primary"
                            @click="handleDelete(index)"
                            style="margin: 0 10px 22px"
                            >删除</el-button
                          >
                        </li>
                      </ul>
                    </div>
                    <div slot="header" class="clearfix">
                      <span>时段设置/最大充电功率</span>
                    </div>

                    <div class="">
                      <el-time-select
                        class="myselect"
                        v-model="form.startTime"
                        :picker-options="{
                          start: '00:00',
                          step: '00:30',
                          end: '24:00',
                        }"
                        @change="selectedTime"
                        placeholder="选择时间"
                      >
                      </el-time-select>
                      <span style="margin: 0 10px 22px">至</span>

                      <el-time-select
                        class="myselect"
                        v-model="form.endTime"
                        :picker-options="{
                          start: '00:00',
                          step: '00:30',
                          end: '24:00',
                          minTime: form.startTime,
                        }"
                        @change="selectedTime"
                        placeholder="选择时间"
                      >
                      </el-time-select>

                      <el-input
                        v-model="form.maxPower"
                        style="width: 100px"
                        placeholder="最大充电功率"
                      ></el-input>
                      kW

                      <el-button
                        type="primary"
                        @click="handleAdd"
                        style="margin: 0 10px 22px"
                        >添加</el-button
                      >
                    </div>
                  </el-card>
                </el-col>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm('editForm')"
            >确认保存</el-button
          >
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../js/upload.component.js";
import { AxiosAjax } from "../../js/axios.config";

let self = this;
export default {
  data() {
    return {
      disabled: true,
      activeName: "account", //当前选项卡
      labelPosition: "right", //表单对齐方式
      modeList: [
        { id: -1, title: "请选择..." },
        { id: 4, title: "充电" },
        { id: 5, title: "放电" },
        { id: 1, title: "空闲" },
        { id: 3, title: "故障" },
      ], //模式列表
      feeList: [
        { id: -1, title: "请选择...", priceType: "" },
        { id: 1, title: "尖时", priceType: "J" },
        { id: 2, title: "峰时", priceType: "F" },
        { id: 3, title: "平时", priceType: "P" },
        { id: 4, title: "谷时", priceType: "G" },
      ], //模式列表
      companyList: [], //公司列表
      seasonList: [
        {
          id: 1,
          season: "非夏季",
          seasonType: "NORMAL",
        },
        {
          id: 2,
          season: "夏季",
          seasonType: "SUMMER",
        },
      ], //季别
      form: {
        startTime: null,
        endTime: null,
      },
      model: {
        regionId: "",
        periodList: [],
        seasonType: "",
        seasonName: "",
        seasonMark: "",
        monthCount: 0,
      },
      rules: {
        feeName: [{ required: true, message: "必填项", trigger: "blur" }],
        companyId: [{ required: true, message: "必填项", trigger: "blur" }],
      },
    };
  },
  methods: {
    getSeasons() {
      this.seasonList.forEach((item) => {
        if (item.dicValue == this.model.seasonType) {
          this.model.seasonName = item.dicName;
        }
      });
    },
    getSeasonal() {
      var _this = this;
      AxiosAjax({
        url: "/calculation/data/season_items",
        success: function (res) {
          if (res.data.code == 200) {
            _this.seasonList = res.data.data;
          }
        },
      });
    },

    submitForm: function () {
      let _this = this; //当前页面

      var bol = "";
      for (let i = 0; i < _this.model.periodList.length; i++) {
        if (_this.model.periodList[i].startTime == "00:00") {
          bol += "Y";
        }

        if (_this.model.periodList[i].endTime == "24:00") {
          _this.model.periodList[i].endTime = "23:59";
          bol += "Y";
        }
      }

      if (bol != "YY") {
        _this.$message({
          type: "warning",
          message: "请已 00:00 到 24:00 结束...",
        });

        return;
      }

      //   多个表单验证;
      const f1 = new Promise((resolve, reject) => {
        _this.$refs["editForm1"].validate((valid) => {
          if (valid) resolve();
        });
      });
      _this.model.regionId = this.$route.query.id || "";
      Promise.all([f1]).then(() => {
        AxiosAjax({
          url: "/calculation/period",
          method: "post",
          data: _this.model,
          success: function (res) {
            _this.model.monthCount = 0;
            _this.regionId = "";
            _this.periodList = [];
            _this.seasonType = "";
            if (res.data.code == 200) {
              _this.$message({
                message: "添加成功",
                type: "success",
              });
              _this.$router.push({ name: "Calculation" });
            }
          },
        });
      });
    },
    resetForm() {
      this.$router.push({ name: "Calculation" });
    },
    handleAdd() {
      var _this = this;

      var _bol = false;
      var _endTime = "";
      for (let i = 0; i < _this.model.periodList.length; i++) {
        _endTime = _this.model.periodList[i].endTime;
      }

      if (_endTime == "") {
        if ("00:00" == _this.form.startTime) {
          _bol = true;
        }
      } else {
        if (_endTime == _this.form.startTime) {
          _bol = true;
        }
      }

      if (_bol) {
        _this.model.periodList.push({
          startTime: _this.form.startTime,
          endTime: _this.form.endTime,
          chargeType: 3,
          priceType: "",
          remark: "",
        });
      } else {
        _this.$message({
          type: "warning",
          message: "要按顺序添加时间...",
        });
      }
    },
    handleDelete(index) {
      var _this = this;

      var ls = [];

      for (let i = 0; i < _this.model.periodList.length; i++) {
        if (i != index) {
          ls.push(_this.model.periodList[i]);
        }
      }

      _this.model.periodList = ls;
    },
    selectedTime() {
      if (this.startTime && this.endTime) {
        this.addErrMsg = null;
      }
    },
    setCompanyId: function (obj) {
      this.model.companyId = obj.toString();
    },
  },
  created: function () {},
  mounted: function () {
    this.getSeasonal();
  },
};
</script>
<style scoped>
.dl-box-fee .el-input {
  width: 20%;
}
.dl-box-fee /deep/ .el-form-item__label {
  min-width: 80px;
}
.dl-box .el-form-item__label {
  font-weight: bold;
}
.el-date-editor.el-input {
  width: 150px;
}
.myselect .el-input {
  width: 100px;
}
.card-form {
  display: flex;
}
.card-form /deep/ .el-col {
  flex: 1;
}
.el-col-24 {
  margin-top: 45px;
}
</style>


// WEBPACK FOOTER //
// src/components/Calculation/CalculationEditTime.vue